import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { MenuSearchBarService } from "./service/menu-search-bar.service";
import { ApiUrlConstant } from "../../constants/api-url.constant";
import { ToastrService } from "ngx-toastr"
import { PermissionUrlService } from './../../../shared/services/permissions.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocalStorageService } from "./../../../shared/services/local-storage.service";
import { environment } from "../../../../environments/environment";
import { SettingsConstant } from "@app/shared/constants/settings.constants";

@Component({
  selector: "menu-search-bar",
  templateUrl: "./menu-search-bar.component.html",
  styleUrls: ["./menu-search-bar.component.scss"],
  providers: [MenuSearchBarService]
})
export class MenuSearchBarComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  innerWidth = window.innerWidth;
  innerHeight = window.innerHeight;
  showSearch = false;
  selectedOption = "Order ID";
  userPermission = '';
  constructor(
    private router: Router,
    private dataservice: MenuSearchBarService,
    private ApiUrl: ApiUrlConstant,
    private toastr: ToastrService,
    private permissions: PermissionUrlService,
    private localStorage: LocalStorageService
  ) {
    let scopes = this.localStorage.getItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES}`);
    this.userPermission = scopes || [];
  }
  ID: any = null;
  placeholder = "Enter Order ID";
  dropDownItems = ["Order ID", "Invoice ID", "AWB/Txn ID"];
  selectedID = "Order ID";

  changeIdType(data) {
    this.selectedID = data;
    if (data === this.dropDownItems[0]) {
      this.placeholder = "Enter Order ID";
    } else if (data === this.dropDownItems[1]) {
      this.placeholder = "Enter Invoice ID";
    } else if (data === this.dropDownItems[2]) {
      this.placeholder = "Enter AWB/Txn ID";
    }
  }

  trackId(value) {
    if (value === "Order ID") {
      this.dataservice
        .getSearchData(this.ApiUrl.MOVEMENT_DETAILS_ORDERS, { 'order_number': this.ID })
        .pipe(takeUntil(this.unsubscribe)).subscribe(data => {
          if (data.data.length && data.data[0].order_id && data.data[0].entity_type) {
            this.searchOrderId(data.data[0].order_id, data.data[0].entity_type);
          } else {
            this.toastr.error("No Order id Found");
          }
        });
    }
    if (value === "AWB/Txn ID") {
      this.dataservice
        .getSearchData(this.ApiUrl.MOVEMENT_DETAILS_ORDERS, { 'master_awb_number': this.ID })
        .pipe(takeUntil(this.unsubscribe)).subscribe(data => {
          if (data.data.length && data.data[0].order_id && data.data[0].entity_type) {
            const respData = data.data[0];
            let awbID = 0;
            for (let i = 0; i < respData.shipments.length; i++) {
              if (this.ID === respData.shipments[i].master_awb_number) {
                awbID = respData.shipments[i].master_awb_id;
                break;
              }
            }
            this.searchAwbLr(awbID, respData.entity_type);
          } else {
            this.toastr.error("No AWB/Txn ID Found");
          }
        });
    }
    if (value === "Invoice ID") {
      this.dataservice
        .getSearchData(this.ApiUrl.MOVEMENT_DETAILS_ORDERS, { 'invoice_number': this.ID })
        .pipe(takeUntil(this.unsubscribe)).subscribe(data => {
          if (data.data.length && data.data[0].order_id && data.data[0].entity_type) {
            this.searchOrderId(data.data[0].order_id, data.data[0].entity_type);
          } else {
            this.toastr.error("No Invoice id Found");

          }
        });
    }
  }
  toggleSearch() {
    this.showSearch = !this.showSearch;
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;

  }
  searchOrderId(id, entity_type) {
    this.showSearch = false;
    let url = ''
    let access = false;
    let viewPermission = [];
    if (entity_type === 'OMS') {
      if (this.userPermission) {
        viewPermission = this.permissions.MOVEMENT_DETAIL_DELIVERY_TAB;
        if (viewPermission.some(elem => this.userPermission.indexOf(elem) > -1)) {
          access = true;
        }
      }
      url = `/orderdetail/${entity_type}/${id}`
    } else if (entity_type === 'AGN') {
      if (this.userPermission) {
        viewPermission = this.permissions.MOVEMENT_DETAIL_INWARD_TAB;
        if (viewPermission.some(elem => this.userPermission.indexOf(elem) > -1)) {
          access = true;
        }
      }
      url = `/agndetails/${entity_type}/${id}`
    }
    if (access) {
      this.router.navigateByUrl(`${url}`);
    } else {
      this.toastr.error("You don't have permission to view this page");
    }
  }
  searchAwbLr(id, entity_type) {
    this.showSearch = false;
    let url = ''
    let access = false;
    let viewPermission = [];
    if (entity_type === 'OMS') {
      if (this.userPermission) {
        viewPermission = this.permissions.MOVEMENT_DETAIL_DELIVERY_TAB;
        if (viewPermission.some(elem => this.userPermission.indexOf(elem) > -1)) {
          access = true;
        }
      }
      url = `/awbdetail/${entity_type}/${id}`
    } else if (entity_type === 'AGN') {
      if (this.userPermission) {
        viewPermission = this.permissions.MOVEMENT_DETAIL_INWARD_TAB;
        if (viewPermission.some(elem => this.userPermission.indexOf(elem) > -1)) {
          access = true;
        }
      }
      url = `/awbdetail/${entity_type}/${id}`
    }
    if (access) {
      this.router.navigateByUrl(`${url}`);
    } else {
      this.toastr.error("You don't have permission to view this page");
    }
  }
  ngOnInit() { }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
